import React, { useState } from "react";
import Snackbar from "@material-ui/core/Snackbar";
import Slide from "@material-ui/core/Slide";
import Alert from "@material-ui/lab/Alert";
import { Portal } from "@material-ui/core";

export const withSnackbar = WrappedComponent => {
  return props => {
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState("");
    const [duration, setDuration] = useState(2000);
    const [vertical, setVertical] = useState("bottom");
    const [horizontal, setHorizontal] = useState("center");
    const [severity, setSeverity] = useState(
      "success"
    );

    const showMessage = (message, severity = "success", duration = 2000, vertical = 'bottom', horizontal= 'center') => {
      setMessage(message);
      setSeverity(severity);
      setDuration(duration);
      setOpen(true);
      setVertical(vertical);
      setHorizontal(horizontal);
    };

    const handleClose = (event, reason) => {
      if (reason === "clickaway") {
        return;
      }
      setOpen(false);
    };

    return (
      <>
        <WrappedComponent {...props} snackbarShowMessage={showMessage} />
        <Portal>
          <Snackbar
            anchorOrigin={{
              vertical,
              horizontal
            }}
            autoHideDuration={duration}
            open={open}
            onClose={handleClose}
            TransitionComponent={Slide}
          >
            <Alert variant="filled" severity={severity}>
              {message}
            </Alert>
          </Snackbar>
        </Portal>
      </>
    );
  };
};
